import type * as Marzipano from 'marzipano';

export function easeOutCubic(t: number): number {
  return 1 - (1 - t) ** 3;
}

export function easeInCubic(t: number): number {
  return t ** 3;
}

/** Crossfade cảnh cũ/mới — mượt hơn fade opacity tuyến tính mặc định của Marzipano. */
export function crossfadeSceneTransition(
  t: number,
  newScene: Marzipano.Scene,
  oldScene: Marzipano.Scene | null
): void {
  const enter = easeOutCubic(t);
  const exit = easeInCubic(1 - t);

  newScene.listLayers().forEach((layer) => {
    layer.mergeEffects({ opacity: enter });
  });

  if (oldScene) {
    oldScene.listLayers().forEach((layer) => {
      layer.mergeEffects({ opacity: exit });
    });
  }

  const hotspotRoot = newScene.hotspotContainer().domElement();
  hotspotRoot.style.opacity = String(enter);
}
